import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    home_title: "WORLD VOTING MAPS",
    home_subtitle: "Settle the debates. Map the world's opinions.",
    explore: "Explore Battles",
    create_map: "Create Map",
    login: "Login",
    signup: "Sign Up",
    logout: "Logout",
    vote_now: "Cast Your Vote",
    meme_studio: "Meme Studio",
    live_tally: "Live Tally",
    vs: "VS",
    create_meme_btn: "Create a Meme",
    region: "Region",
    share: "Share to Facebook",
    download: "Download Image",
    meme_warning: "Fan Meme — not official results",
    create_new_battle: "Create New Battle",
    option_a: "Option A",
    option_b: "Option B",
    submit: "Submit",
    map_created: "Map created successfully!",
    auth_required: "You must be logged in to do this.",
    all_regions: "All Regions",
    no_maps_found: "No maps found for this region.",
    battle_title: "Battle Title",
    select_region: "Select Region",
    email: "Email Address",
    password: "Password",
    dont_have_account: "Don't have an account?",
    already_have_account: "Already have an account?",
    required_fields: "Please fill in all required fields.",
    loading: "Loading...",
    map_not_found: "Map not found",
    go_home: "Go Back Home",
    vote_success: "Vote recorded!",
    max_votes: "Maximum 2 votes allowed.",
    meme_success: "Meme ready to download!",
    meme_sharing: "Uploading…",
    meme_share_error: "Failed to share meme. Please try again.",
    meme_export_error: "Failed to generate image.",
    voting_as: "Voting as",
    select_identity: "Select Your Identity",
    identity_locked_desc: "You have locked your voting identities to these countries:",
    identity_new_desc: "Select the country you are voting from. This will lock your identity.",
    locked_tooltip: "Locked — you've already voted as {0} and {1}.",
    change_identity_msg: "Signed in users can update their country selection.",
    confirm_vote: "Confirm Vote",
    search_countries: "Search countries...",
    change: "Change",
    select_option: "Choose Your Vote",
    select_option_desc: "Which side are you voting for?",
    vote_for: "Vote {0}",
    use_second_vote: "Use Your 2nd Vote",
    change_country_signup: "Want to change your country? Sign up to update it.",
    country_detect_failed: "Could not detect your country. Please refresh and try again.",
    second_vote_click_map: "Identity set! Click a territory on the map to cast your 2nd vote.",
    identity_lock_status: "Identity Lock Status",
    click_territory_to_vote: "Click territories on the map to vote.",
    locked_to_voting: "You're locked to voting as {0} and {1}.",
    confirm_identity: "Confirm Identity",
    map_votes_exhausted: "You've used both your votes on this battle.",
    already_voted_as: "You've already voted on this map as {0}.",
    profile: "Profile",
    profile_title: "Your Profile",
    profile_display_name: "Display Name",
    profile_locked_countries: "Locked Voting Countries",
    profile_no_identity: "No voting identity linked yet. Cast a vote while signed in to lock your countries.",
    profile_change_hint: "Changing a country invalidates your prior votes cast under the old identity across all maps.",
    profile_change_country_title: "Change Country",
    profile_change_country_desc: "Choose a replacement for {0}. Prior votes under the old country will be invalidated.",
    profile_confirm_change: "Confirm Change",
    profile_no_countries: "No matching countries.",
    profile_change_success: "Identity updated from {0} to {1}. Prior votes under the old country were invalidated.",
    profile_change_error: "Could not change country. Please try again.",
    profile_load_error: "Could not load profile.",
    profile_error_duplicate: "That country is already one of your locked identities.",
    profile_error_mismatch: "That country is not one of your current locked identities.",
    profile_error_no_identity: "No voting identity is linked to your account yet.",
    profile_error_invalid: "Please choose a different country.",
    profile_vote_history: "Voting History",
    profile_voted_as: "Voted as {0}",
    profile_voted_for: "Chose {0}",
    profile_show_invalidated: "Show invalidated votes",
    profile_hide_invalidated: "Hide invalidated votes",
    profile_invalidated: "Invalidated",
    profile_no_votes: "You haven't cast any votes yet.",
    miracle_calculator: "The Miracle Calculator",
    chances_team_trailing: "Trailing team",
    chances_team_leading: "Leading team",
    chances_quick_pick: "Country",
    chances_custom: "Custom",
    chances_clear: "Clear",
    chances_team_name_placeholder: "Team name…",
    chances_emoji_label: "Icon",
    chances_generic_teams: "Generic labels — pick teams to personalize",
    chances_customize_heading: "Customize your own Calculator"
  },
  es: {
    home_title: "MAPAS DE VOTACIÓN MUNDIAL",
    home_subtitle: "Resuelve los debates. Mapea las opiniones del mundo.",
    explore: "Explorar Batallas",
    create_map: "Crear Mapa",
    login: "Iniciar Sesión",
    signup: "Registrarse",
    logout: "Cerrar Sesión",
    vote_now: "Vota Ahora",
    meme_studio: "Estudio de Memes",
    live_tally: "Recuento en Vivo",
    vs: "VS",
    create_meme_btn: "Crear un Meme",
    region: "Región",
    share: "Compartir en Facebook",
    download: "Descargar Imagen",
    meme_warning: "Meme de Fan — no son resultados oficiales",
    create_new_battle: "Crear Nueva Batalla",
    option_a: "Opción A",
    option_b: "Opción B",
    submit: "Enviar",
    map_created: "¡Mapa creado con éxito!",
    auth_required: "Debes iniciar sesión para hacer esto.",
    all_regions: "Todas las Regiones",
    no_maps_found: "No se encontraron mapas para esta región.",
    battle_title: "Título de la Batalla",
    select_region: "Seleccionar Región",
    email: "Correo Electrónico",
    password: "Contraseña",
    dont_have_account: "¿No tienes una cuenta?",
    already_have_account: "¿Ya tienes una cuenta?",
    required_fields: "Por favor complete todos los campos requeridos.",
    loading: "Cargando...",
    map_not_found: "Mapa no encontrado",
    go_home: "Volver al Inicio",
    vote_success: "¡Voto registrado!",
    max_votes: "Máximo 2 votos permitidos.",
    meme_success: "¡Meme listo para descargar!",
    meme_sharing: "Subiendo…",
    meme_share_error: "No se pudo compartir el meme. Inténtalo de nuevo.",
    meme_export_error: "No se pudo generar la imagen.",
    voting_as: "Votando como",
    select_identity: "Selecciona tu Identidad",
    identity_locked_desc: "Has bloqueado tus identidades de votación a estos países:",
    identity_new_desc: "Selecciona el país desde el que votas. Esto bloqueará tu identidad.",
    locked_tooltip: "Bloqueado — ya has votado como {0} y {1}.",
    change_identity_msg: "Los usuarios registrados pueden actualizar su selección de país.",
    confirm_vote: "Confirmar Voto",
    search_countries: "Buscar países...",
    change: "Cambiar",
    select_option: "Elige tu Voto",
    select_option_desc: "¿Por cuál lado votas?",
    vote_for: "Votar {0}",
    use_second_vote: "Usa tu 2do Voto",
    change_country_signup: "¿Quieres cambiar tu país? Regístrate para actualizarlo.",
    country_detect_failed: "No se pudo detectar tu país. Actualiza e inténtalo de nuevo.",
    second_vote_click_map: "¡Identidad lista! Haz clic en un territorio del mapa para tu 2do voto.",
    identity_lock_status: "Estado de Bloqueo de Identidad",
    click_territory_to_vote: "Haz clic en territorios del mapa para votar.",
    locked_to_voting: "Estás bloqueado para votar como {0} y {1}.",
    confirm_identity: "Confirmar Identidad",
    map_votes_exhausted: "Ya usaste tus dos votos en esta batalla.",
    already_voted_as: "Ya votaste en este mapa como {0}.",
    profile: "Perfil",
    profile_title: "Tu Perfil",
    profile_display_name: "Nombre para Mostrar",
    profile_locked_countries: "Países de Votación Bloqueados",
    profile_no_identity: "Aún no hay identidad de votación vinculada. Vota mientras estés conectado para bloquear tus países.",
    profile_change_hint: "Cambiar un país invalida tus votos anteriores bajo la identidad antigua en todos los mapas.",
    profile_change_country_title: "Cambiar País",
    profile_change_country_desc: "Elige un reemplazo para {0}. Los votos anteriores bajo el país antiguo serán invalidados.",
    profile_confirm_change: "Confirmar Cambio",
    profile_no_countries: "No hay países coincidentes.",
    profile_change_success: "Identidad actualizada de {0} a {1}. Los votos anteriores bajo el país antiguo fueron invalidados.",
    profile_change_error: "No se pudo cambiar el país. Inténtalo de nuevo.",
    profile_load_error: "No se pudo cargar el perfil.",
    profile_error_duplicate: "Ese país ya es una de tus identidades bloqueadas.",
    profile_error_mismatch: "Ese país no es una de tus identidades bloqueadas actuales.",
    profile_error_no_identity: "Aún no hay identidad de votación vinculada a tu cuenta.",
    profile_error_invalid: "Por favor elige un país diferente.",
    profile_vote_history: "Historial de Votos",
    profile_voted_as: "Votó como {0}",
    profile_voted_for: "Eligió {0}",
    profile_show_invalidated: "Mostrar votos invalidados",
    profile_hide_invalidated: "Ocultar votos invalidados",
    profile_invalidated: "Invalidado",
    profile_no_votes: "Aún no has emitido ningún voto.",
    miracle_calculator: "La Calculadora Milagrosa",
    chances_team_trailing: "Equipo que va perdiendo",
    chances_team_leading: "Equipo que va ganando",
    chances_quick_pick: "País",
    chances_custom: "Personalizado",
    chances_clear: "Borrar",
    chances_team_name_placeholder: "Nombre del equipo…",
    chances_emoji_label: "Ícono",
    chances_generic_teams: "Etiquetas genéricas — elige equipos para personalizar",
    chances_customize_heading: "Personaliza tu propia Calculadora"
  }
};

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  const t = (key, ...args) => {
    let text = translations[lang][key] || key;
    if (args.length > 0) {
      args.forEach((arg, i) => {
        text = text.replace(`{${i}}`, arg);
      });
    }
    return text;
  };
  const toggleLang = () => setLang(prev => prev === 'en' ? 'es' : 'en');

  return (
    <LangContext.Provider value={{ lang, t, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);